/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsObjectsIntegrationType } from './WebApiIntegrationsObjectsIntegrationType';
import {
    WebApiIntegrationsObjectsIntegrationTypeFromJSON,
    WebApiIntegrationsObjectsIntegrationTypeFromJSONTyped,
    WebApiIntegrationsObjectsIntegrationTypeToJSON,
} from './WebApiIntegrationsObjectsIntegrationType';

/**
 * 
 * @export
 * @interface WebApiAdminDtoInvoiceGenerationRequest
 */
export interface WebApiAdminDtoInvoiceGenerationRequest {
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoInvoiceGenerationRequest
     */
    companyId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoInvoiceGenerationRequest
     */
    invoiceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoInvoiceGenerationRequest
     */
    customerReferenceName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoInvoiceGenerationRequest
     */
    customerReferenceAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoInvoiceGenerationRequest
     */
    customerReferenceZipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoInvoiceGenerationRequest
     */
    customerReferenceCity?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoInvoiceGenerationRequest
     */
    subscriptionPriceOverride?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoInvoiceGenerationRequest
     */
    integrationPriceOverride?: number | null;
    /**
     * 
     * @type {WebApiIntegrationsObjectsIntegrationType}
     * @memberof WebApiAdminDtoInvoiceGenerationRequest
     */
    forceIntegrationType?: WebApiIntegrationsObjectsIntegrationType;
}

/**
 * Check if a given object implements the WebApiAdminDtoInvoiceGenerationRequest interface.
 */
export function instanceOfWebApiAdminDtoInvoiceGenerationRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoInvoiceGenerationRequestFromJSON(json: any): WebApiAdminDtoInvoiceGenerationRequest {
    return WebApiAdminDtoInvoiceGenerationRequestFromJSONTyped(json, false);
}

export function WebApiAdminDtoInvoiceGenerationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoInvoiceGenerationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'invoiceNumber': !exists(json, 'invoiceNumber') ? undefined : json['invoiceNumber'],
        'customerReferenceName': !exists(json, 'customerReferenceName') ? undefined : json['customerReferenceName'],
        'customerReferenceAddress': !exists(json, 'customerReferenceAddress') ? undefined : json['customerReferenceAddress'],
        'customerReferenceZipCode': !exists(json, 'customerReferenceZipCode') ? undefined : json['customerReferenceZipCode'],
        'customerReferenceCity': !exists(json, 'customerReferenceCity') ? undefined : json['customerReferenceCity'],
        'subscriptionPriceOverride': !exists(json, 'subscriptionPriceOverride') ? undefined : json['subscriptionPriceOverride'],
        'integrationPriceOverride': !exists(json, 'integrationPriceOverride') ? undefined : json['integrationPriceOverride'],
        'forceIntegrationType': !exists(json, 'forceIntegrationType') ? undefined : WebApiIntegrationsObjectsIntegrationTypeFromJSON(json['forceIntegrationType']),
    };
}

export function WebApiAdminDtoInvoiceGenerationRequestToJSON(value?: WebApiAdminDtoInvoiceGenerationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'invoiceNumber': value.invoiceNumber,
        'customerReferenceName': value.customerReferenceName,
        'customerReferenceAddress': value.customerReferenceAddress,
        'customerReferenceZipCode': value.customerReferenceZipCode,
        'customerReferenceCity': value.customerReferenceCity,
        'subscriptionPriceOverride': value.subscriptionPriceOverride,
        'integrationPriceOverride': value.integrationPriceOverride,
        'forceIntegrationType': WebApiIntegrationsObjectsIntegrationTypeToJSON(value.forceIntegrationType),
    };
}

